
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { CommonSearchIVO, CommonSearchOVO } from '@/views/biz/omr/vo/SearchVO.vo'
import { ReportHistoryOVO } from '@/views/biz/omr/vo/Omr.vo'
import ReportHistoryComponent from '@/components/ReportHistoryComponent.vue'
import Constants from '@/constants'
import CommonUtils from '@/common-utils'
import axios from 'axios'

@Component({
  components: {ReportHistoryComponent}
})
export default class OmrReportHistory extends Vue {
  @Prop() emExam !: string;
  @Prop() smNo !: string;
}
